import { useState } from "react";
import { APP_NAME } from "../../../constants/constants";
import "./frame.css";

const metrics = [
  { label: "Total Portfolio", value: "UGX 44.8M", tag: "+8.2%", cls: "tag-g" },
  { label: "Active Loans", value: "1,248", tag: "+12 this week", cls: "tag-g" },
  {
    label: "Overdue Accounts",
    value: "37",
    tag: "+3 from last week",
    cls: "tag-r",
  },
  { label: "Avg. Credit Score", value: "712", tag: "Good", cls: "tag-b" },
];

const loans = [
  {
    id: "LN-00481",
    name: "Elena Mary",
    type: "Mortgage",
    amount: "UGX 2,850,000",
    rate: "6.4%",
    status: "active",
    pct: 22,
  },
  {
    id: "LN-00479",
    name: "James Okello",
    type: "Business",
    amount: "UGX 480,000",
    rate: "9.1%",
    status: "pending",
    pct: 0,
  },
  {
    id: "LN-00476",
    name: "Joan Edith",
    type: "Personal",
    amount: "UGX 120,500",
    rate: "11.5%",
    status: "active",
    pct: 68,
  },
  {
    id: "LN-00474",
    name: "Grace Pearl",
    type: "Auto",
    amount: "UGX 220,000",
    rate: "7.8%",
    status: "overdue",
    pct: 45,
  },
  {
    id: "LN-00471",
    name: "John Ivan",
    type: "Education",
    amount: "UGX 340,000",
    rate: "5.2%",
    status: "active",
    pct: 85,
  },
  {
    id: "LN-00468",
    name: "Matthew Mwesigwa",
    type: "Personal",
    amount: "UGX 80,000",
    rate: "13.0%",
    status: "closed",
    pct: 100,
  },
];

const statusMap = {
  active: { label: "Active", cls: "b-act" },
  pending: { label: "Pending", cls: "b-pen" },
  overdue: { label: "Overdue", cls: "b-ov" },
  closed: { label: "Closed", cls: "b-cl" },
};

const barCls = (status, pct) => {
  if (status === "overdue") return "warn";
  if (pct === 100) return "done";
  return "";
};

const scores = [
  { label: "Excellent  750+", pct: 28, color: "#1A7A4A" },
  { label: "Good  700–749", pct: 35, color: "#111110" },
  { label: "Fair  650–699", pct: 22, color: "#A8A8A5" },
  { label: "Poor  <650", pct: 15, color: "#C0392B" },
];

const feed = [
  {
    color: "#1A7A4A",
    text: "LN-00481 disbursed to John Ivan",
    time: "2 min ago",
  },
  {
    color: "#1A5FAB",
    text: "New application submitted by Matthew Mwesigwa",
    time: "18 min ago",
  },
  {
    color: "#C0392B",
    text: "Grace Pearl missed scheduled repayment",
    time: "1 hr ago",
  },
  // {
  //   color: "#A8A8A5",
  //   text: "Credit scores updated — 42 accounts",
  //   time: "3 hr ago",
  // },
];

const tabs = ["Overview", "Applications", "Accounts"];

export default function LoanDashboardMinimal() {
  const [activeTab, setActiveTab] = useState("Overview");

  return (
    <>
      <div className="d-root">
        <header className="header">
          <div className="header-left">
            <span className="logo">{APP_NAME}</span>
            <nav className="nav">
              {tabs.map((t) => (
                <button
                  key={t}
                  className={`nav-btn${activeTab === t ? " active" : ""}`}
                  onClick={() => setActiveTab(t)}
                >
                  {t}
                </button>
              ))}
            </nav>
          </div>
          <div className="header-right">
            <button className="hbtn hbtn-ghost">Export</button>
            <button className="hbtn hbtn-solid">+ New Loan</button>
          </div>
        </header>

        <main className="content">
          <div className="metrics">
            {metrics.map((m, i) => (
              <div className="metric" key={i}>
                <div className="metric-label">{m.label}</div>
                <div className="metric-value">{m.value}</div>
                <span className={`metric-tag ${m.cls}`}>{m.tag}</span>
              </div>
            ))}
          </div>

          <div className="row">
            <div className="card">
              <div className="card-head">
                <span className="card-title">Loan Accounts</span>
                <button className="card-link">View All →</button>
              </div>
              <table>
                <thead>
                  <tr>
                    <th style={{ width: "20%" }}>Borrower</th>
                    <th style={{ width: "14%" }}>Type</th>
                    <th style={{ width: "16%" }}>Amount</th>
                    <th style={{ width: "10%" }}>Rate</th>
                    <th style={{ width: "12%" }}>Status</th>
                    <th style={{ width: "14%" }}>Repaid</th>
                  </tr>
                </thead>
                <tbody>
                  {loans.map((l, i) => {
                    const s = statusMap[l.status];
                    return (
                      <tr
                        key={i}
                        data-aos="fade-up"
                        data-aos-offset="50"
                        data-aos-delay={i + 1 * 100}
                        data-aos-duration="1000"
                      >
                        <td>
                          <div>{l.name}</div>
                          <div style={{ fontSize: 11, color: "var(--text-3)" }}>
                            {l.id}
                          </div>
                        </td>
                        <td className="dim">{l.type}</td>
                        <td style={{ fontVariantNumeric: "tabular-nums" }}>
                          {l.amount}
                        </td>
                        <td className="dim">{l.rate}</td>
                        <td>
                          <span className={`badge ${s.cls}`}>{s.label}</span>
                        </td>
                        <td>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                            }}
                          >
                            <div className="bar-track">
                              <div
                                className={`bar-fill ${barCls(l.status, l.pct)}`}
                                style={{ width: `${l.pct}%` }}
                              />
                            </div>
                            <span
                              style={{ fontSize: 11, color: "var(--text-3)" }}
                            >
                              {l.pct}%
                            </span>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="right-col">
              <div className="card">
                <div className="card-head">
                  <span className="card-title">Credit scores</span>
                  <button className="card-link">Details →</button>
                </div>
                <div className="score-body">
                  {scores.map((s, i) => (
                    <div
                      className="score-row"
                      key={i}
                      data-aos="fade-up"
                      data-aos-offset="50"
                      data-aos-delay={i + 1 * 100}
                      data-aos-duration="1000"
                    >
                      <span className="score-label">{s.label}</span>
                      <div className="score-track">
                        <div
                          className="score-bar"
                          style={{ width: `${s.pct}%`, background: s.color }}
                        />
                      </div>
                      <span className="score-pct">{s.pct}%</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="card">
                <div className="card-head">
                  <span className="card-title">Activity</span>
                  <button className="card-link">All →</button>
                </div>
                <div className="feed-body">
                  {feed.map((f, i) => (
                    <div
                      className="feed-item"
                      key={i}
                      data-aos="fade-up"
                      data-aos-delay={i + 1 * 100}
                      data-aos-duration="1000"
                    >
                      <div className="fdot" style={{ background: f.color }} />
                      <div>
                        <div className="feed-text">{f.text}</div>
                        <div className="feed-time">{f.time}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}
